import { getToken } from 'firebase/messaging';
import { firebaseMessaging } from 'src/web/firebase';
import initFirebase from 'src/web/firebase';
import ensureMessagingServiceWorker from 'src/web/ensureMessagingServiceWorker';
const VAPID_KEY = 'BNkP4zume4Rt20wGPZlFEznQA7X7gA2Zk5M6xDaJVHm0HqYG1PqtyQelJT8HFc2ZSFXb9VzYSZfu--kzXX11w70';
export default function registerTokenListener(onTokenUpdate) {
    initFirebase().then(async () => {
        if (!firebaseMessaging) {
            return;
        }
        const registration = await ensureMessagingServiceWorker();
        if (!registration) {
            return;
        }
        try {
            const currentToken = await getToken(firebaseMessaging, {
                vapidKey: VAPID_KEY,
                serviceWorkerRegistration: registration,
            });
            if (currentToken) {
                onTokenUpdate(currentToken);
            }
        }
        catch (error) {
            console.warn('Failed to get FCM token:', error);
        }
    });
}
